"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n    text-align: center;\n"], ["\n    text-align: center;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _tab = require("./tabs/tab");

var _tab2 = _interopRequireDefault(_tab);

var _tabContainer = require("./tabs/tabContainer");

var _tabContainer2 = _interopRequireDefault(_tabContainer);

var _tabContent = require("./tabs/tabContent");

var _tabContent2 = _interopRequireDefault(_tabContent);

var _accordion = require("./accordion/accordion");

var _accordion2 = _interopRequireDefault(_accordion);

var _accordionHeader = require("./accordion/accordionHeader");

var _accordionHeader2 = _interopRequireDefault(_accordionHeader);

var _accordionContent = require("./accordion/accordionContent");

var _accordionContent2 = _interopRequireDefault(_accordionContent);

var _steps = require("./steps/steps");

var _steps2 = _interopRequireDefault(_steps);

var _step = require("./steps/step");

var _step2 = _interopRequireDefault(_step);

var _row = require("./row");

var _row2 = _interopRequireDefault(_row);

var _column = require("./column");

var _column2 = _interopRequireDefault(_column);

var _button = require("./button");

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StepsContainer = _styledComponents2.default.div(_templateObject);

var Tabordion = function (_React$Component) {
    _inherits(Tabordion, _React$Component);

    function Tabordion(props) {
        _classCallCheck(this, Tabordion);

        var _this = _possibleConstructorReturn(this, (Tabordion.__proto__ || Object.getPrototypeOf(Tabordion)).call(this, props));

        _this.state = {
            current: _this.props.current,
            width: undefined,
            random: _this.randomString()
        };
        return _this;
    }

    _createClass(Tabordion, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            window.addEventListener("resize", this.updateDimensions.bind(this));
            this.updateDimensions();
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            window.removeEventListener("resize", this.updateDimensions.bind(this));
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.current !== nextProps.current) {
                this.setCurrentItem(nextProps.current);
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            if (this.props.cb) this.props.cb();
        }
    }, {
        key: "updateDimensions",
        value: function updateDimensions() {
            this.setState({ width: window.innerWidth });
        }
    }, {
        key: "setCurrentItem",
        value: function setCurrentItem(x) {
            this.setState({ current: x });
        }
    }, {
        key: "randomString",
        value: function randomString() {
            return Math.random().toString(36).substring(7);
        }
    }, {
        key: "position",
        value: function position() {
            return this.state.current;
        }
    }, {
        key: "length",
        value: function length() {
            return _react2.default.Children.count(this.props.children);
        }
    }, {
        key: "prev",
        value: function prev() {
            this.setCurrentItem(this.state.current - 1);
        }
    }, {
        key: "next",
        value: function next() {
            this.setCurrentItem(this.state.current + 1);
        }
    }, {
        key: "handleTabClick",
        value: function handleTabClick(x) {
            this.props.onTabClick();
            if (x) {
                x();
            }
        }
    }, {
        key: "content",
        value: function content(children, unmounts, current) {
            return unmounts ? children[current] : children.map(function (child, i) {
                return _react2.default.createElement(
                    "div",
                    {
                        key: i,
                        style: {
                            display: current == i ? "block" : "none"
                        }
                    },
                    child
                );
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                type = _props.type,
                respondsAt = _props.respondsAt,
                responsive = _props.responsive,
                unmounts = _props.unmounts,
                isWizard = _props.isWizard,
                nextButtonText = _props.nextButtonText,
                prevButtonText = _props.prevButtonText,
                nextButtonDisabled = _props.nextButtonDisabled,
                prevButtonDisabled = _props.prevButtonDisabled,
                wizardColumnProps = _props.wizardColumnProps,
                wizardRowProps = _props.wizardRowProps,
                wizardButtonProps = _props.wizardButtonProps;

            var children = _react2.default.Children.toArray(this.props.children);
            var breakpoint = Boolean(responsive && this.state.width < respondsAt);
            var content = this.content(children, unmounts, this.state.current);

            return _react2.default.createElement(
                "div",
                null,
                type == "tabs" && !breakpoint && _react2.default.createElement(
                    _tabContainer2.default,
                    null,
                    children.map(function (child, i) {
                        return _react2.default.createElement(
                            _tab2.default,
                            {
                                onClick: function onClick() {
                                    return _this2.handleTabClick(_this2.setCurrentItem(i));
                                },
                                divider: _this2.props.divider,
                                current: _this2.state.current,
                                key: i,
                                i: i
                            },
                            child.props.heading
                        );
                    })
                ),
                type == "steps" && !breakpoint && _react2.default.createElement(
                    StepsContainer,
                    null,
                    _react2.default.createElement(
                        _steps2.default,
                        { current: this.state.current },
                        children.map(function (child, i) {
                            return _react2.default.createElement(
                                _step2.default,
                                {
                                    label: child.props.heading,
                                    onClick: function onClick() {
                                        return _this2.handleTabClick(_this2.setCurrentItem(i));
                                    },
                                    divider: _this2.props.divider,
                                    key: "step_" + i,
                                    i: i
                                },
                                child.props.icon
                            );
                        })
                    )
                ),
                (type == "accordion" || breakpoint) && _react2.default.createElement(AccordionGroup, {
                    slice: [0, this.state.current + 1],
                    divider: this.props.divider,
                    current: this.state.current,
                    children: children,
                    handleTabClick: this.handleTabClick.bind(this),
                    cb: this.setCurrentItem.bind(this)
                }),
                content,
                (type == "accordion" || breakpoint) && _react2.default.createElement(AccordionGroup, {
                    slice: [this.state.current + 1, children.length],
                    divider: this.props.divider,
                    current: this.state.current,
                    children: children,
                    handleTabClick: this.handleTabClick.bind(this),
                    cb: this.setCurrentItem.bind(this)
                })
            );
        }
    }]);

    return Tabordion;
}(_react2.default.Component);

var AccordionGroup = function (_React$Component2) {
    _inherits(AccordionGroup, _React$Component2);

    function AccordionGroup() {
        _classCallCheck(this, AccordionGroup);

        return _possibleConstructorReturn(this, (AccordionGroup.__proto__ || Object.getPrototypeOf(AccordionGroup)).apply(this, arguments));
    }

    _createClass(AccordionGroup, [{
        key: "render",
        value: function render() {
            var _props2 = this.props,
                slice = _props2.slice,
                children = _props2.children,
                cb = _props2.cb,
                handleTabClick = _props2.handleTabClick,
                rest = _objectWithoutProperties(_props2, ["slice", "children", "cb", "handleTabClick"]);

            return children.slice(slice[0], slice[1]).map(function (child, i) {
                i = i + slice[0];
                return _react2.default.createElement(
                    _accordionHeader2.default,
                    _extends({
                        onClick: function onClick() {
                            return handleTabClick(cb(i));
                        },
                        key: "header" + i,
                        i: i
                    }, rest),
                    child.props.heading
                );
            });
        }
    }]);

    return AccordionGroup;
}(_react2.default.Component);

Tabordion.displayName = "Tabordion";

Tabordion.propTypes = {
    active: _propTypes2.default.number,
    barClickable: _propTypes2.default.bool,
    allowMultiple: _propTypes2.default.bool,
    type: _propTypes2.default.oneOf(["tabs", "accordion", "steps"]),
    respondsAt: _propTypes2.default.number,
    unmounts: _propTypes2.default.bool,
    responsive: _propTypes2.default.bool,
    /** Callback function for when tab is clicked */
    onTabClick: _propTypes2.default.func
};

Tabordion.defaultProps = {
    active: null,
    barClickable: true,
    allowMultiple: false,
    respondsAt: 600,
    type: "tabs",
    unmounts: true,
    responsive: true
};

exports.default = Tabordion;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/tabordion.js
// module id = 1019
// module chunks = 95715928098905 168707334958949